module.exports = __webpack_public_path__ + "img/wifi.47637152.svg";